import styled from "styled-components";

import Spring from "../../components/Spring";

export const StyledTeacher = styled(Spring)`
    overflow: hidden;
    background-color: ${p => p.theme.c.snow};
    min-height: calc(100vh - 50px);
`;
